package com.milta.core.localization.translations.sq

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Ndodhi një gabim",
    error = "Gabim",
    fieldRequired = "Ky fushë është e detyrueshme",
    invalidEmail = "Adresë emaili e pavlefshme",
    fileTooLarge = "Skedar shumë i madh. Zgjidhni një skedar më të lehtë.",
)
